
import {
  Table, TableBody, Box, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, TextField, MenuItem,

} from "@mui/material";
import { Print, Visibility,} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { generateReceiptPdf } from "../../Accounts/ReceiptVoucherPrint";
const ReceiptVoucher = ({data}) => {
  
  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

 
  return (
    <>
     
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: "48vh",
            overflow: "auto"
          }}
        >
          <Table
            stickyHeader
            size="small"
            sx={{
              minWidth: 1600,
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                backgroundColor: "#f5f5f5",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f5f5f5",
                  "& th": {
                    fontWeight: "bold",
                    color: "#333",
                    borderBottom: "1px solid #999",
                    whiteSpace: "nowrap",
                  },
                }}
              >
              
                <TableCell
                  sx={{
                    position: "sticky",
                
                    backgroundColor: "#f5f5f5",
                    zIndex: 3,
                  }}
                >
                  S.No.
                </TableCell>

                <TableCell>Voucher No</TableCell>
                {/* <TableCell>Status</TableCell> */}
                <TableCell>PI Amt</TableCell>
                <TableCell>Rec Amt</TableCell>

                <TableCell>Project</TableCell>
                <TableCell>Division</TableCell>
                <TableCell>PI No</TableCell>
                <TableCell>Sales voucher No</TableCell>
                <TableCell>Debtor</TableCell>
                <TableCell>Invoice number</TableCell>
                <TableCell>Invoice Date</TableCell>
                {/* <TableCell>Amt</TableCell> */}
                <TableCell>Payment Mode</TableCell>

                <TableCell>Created By</TableCell>
                <TableCell>Approved By</TableCell>
                <TableCell>Remarks</TableCell>
                <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#f5f5f5",
                    zIndex: 3,
                    // minWidth: 180, // Increase width so all icons fit
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((voucher, index) => (
                <TableRow
                  hover
                  key={index}
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#fff",
                    zIndex: 1,

                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                      "& td": {
                        backgroundColor: "#e3f2fd !important",
                      },
                    },
                    "& td": {
                      paddingTop: "2px !important",
                      paddingBottom: "2px !important",
                      fontSize: { xs: "0.75rem", sm: "0.8125rem" }, // responsive font
                      whiteSpace: "nowrap",
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "white" : "inherit",
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "inherit",
                    },
                  }}
                >
              
                  <TableCell
                    sx={{
                      position: "sticky",
              
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    {index + 1}
                  </TableCell>

                  <TableCell> {voucher.receipt_number}</TableCell>
                 
                  <TableCell>
                    {voucher.amount?.toLocaleString("en-IN")}
                  </TableCell>
                  <TableCell>
                    {voucher.rec_amt?.toLocaleString("en-IN")}
                  </TableCell>

                  <TableCell>{voucher.project_name}</TableCell>
                  <TableCell>{voucher.division_name}</TableCell>
                  <TableCell>{voucher.pi_no}</TableCell>
                  <TableCell>{voucher.sales_number}</TableCell>
                  <TableCell>{voucher.party_name}</TableCell>
                  <TableCell>{voucher.invoice_number}</TableCell>
                  <TableCell>
                    {new Date(voucher.invoice_date).toLocaleDateString("en-GB")}
                  </TableCell>
                  {/* <TableCell>{voucher.amount}</TableCell> */}
                  <TableCell>{voucher.payment_mode}</TableCell>

                  <TableCell>{voucher.created_by_name}</TableCell>
                  <TableCell>{voucher.approved_name}</TableCell>
                  <TableCell>
                    <Tooltip title={voucher.remarks || ""} arrow>
                      <span>{truncateText(voucher.remarks || "", 20)}</span>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 180, // Consistent width
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                     

                    

                    
                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        color="warning"
                        size="small"
                        onClick={() => generateReceiptPdf(voucher)}
                      >
                        <Print fontSize="small" />
                      </IconButton>
                     
                      <span
                        style={{
                          display: "inline-block",
                          width: 36,
                          textAlign: "center",
                        }}
                      >
                        {typeof voucher.attachment === "string" ? (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              sx={{
                                padding: 0,
                                paddingLeft: 1,
                                paddingRight: 1,
                              }}
                              color="info"
                              size="small"
                            >
                              <Visibility fontSize="small" />
                            </IconButton>
                          </a>
                        ) : voucher.attachment instanceof File ? (
                          // voucher.attachment.name
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              sx={{
                                padding: 0,
                                paddingLeft: 1,
                                paddingRight: 1,
                              }}
                              color="info"
                              size="small"
                            >
                              <Visibility fontSize="small" />
                            </IconButton>
                          </a>
                        ) : (
                          <span
                            style={{ display: "inline-block", width: 24 }}
                          />
                        )}
                      </span>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
             
            </TableBody>
          </Table>
        </TableContainer>
      


    </>
  );
};

export default ReceiptVoucher;

